<template>
  <div class='welcomecontainer'>
    <img class='logo ma-8' src='../assets/logo.png' />
    <div class='welcome'>Welcome to CM evolveIT Customer Portal</div>
    <div class='welcomesub'>Get Started</div>
    <div class='mx-auto welcomedivider'>
       <v-divider></v-divider>
    </div>
    <div class="centered">
      <v-dialog v-model='getstarteddialog' persistent width='500'>
        <template v-slot:activator='{ on, attrs }'>
          <v-container class="plexsheet">
            <v-row>
              <v-col cols="4" class="w-600">
                <v-sheet height="250" class="rounded blue-grey darken-2">
                  <img class='calogo ma-8 rounded' src='../assets/source.jpg' />
                  <v-btn large class='btn getstarted mainframe' v-bind='attrs' v-on='on'>
                    CA Plex Model
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <v-card @keyup.enter="validateEmailAddress('plex')">
          <v-card-title class='headline grey lighten-2' primary-title>
            Verify Email
          </v-card-title>

          <v-card-text>
            <v-form @submit.prevent="submit">
              <v-container>
                <v-row>
                  <v-text-field
                    v-model='emailaddress'
                    :rules='[rules.required, rules.email]'
                    :hint='hint'
                    label='E-mail'
                    autofocus
                  ></v-text-field>
                  <div id='first-Name' class='d-none'>{{ firstName }}</div>
                  <div id='last-Name' class='d-none'>{{ lastName }}</div>
                </v-row>
                <v-row>
                  <v-dialog v-model='verifydialog' persistent width='500'>
                    <v-card color='primary' dark>
                      <v-card-text>
                        Verifying your email address...
                        <v-progress-linear
                          indeterminate
                          color='white'
                          class='mb-0'
                        ></v-progress-linear>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-row>
                <v-row>
                  <v-alert v-show='emailsuccess' type='success'>
                    Your email address is verified.
                  </v-alert>
                  <v-alert v-show='emailerror' type='error'>
                    We are not able to verify your e-mail. Please sign in via your
                    support website first. Redirecting to our support website...
                  </v-alert>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="getstarteddialog = false"> Close </v-btn>
            
            <v-btn color='primary' @click="validateEmailAddress('plex')"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model='getstartedmainframedialog' persistent width='500'>
        <v-card @keyup.enter="validateEmailAddress('mainframe')">
          <v-card-title class='headline grey lighten-2' primary-title>
            Verify Email
          </v-card-title>

          <v-card-text>
            <v-form @submit.prevent="submit">
              <v-container>
                <v-row>
                  <v-text-field
                    v-model='emailaddress'
                    :rules='[rules.required, rules.email]'
                    :hint='hint'
                    label='E-mail'
                    autofocus
                  ></v-text-field>
                  <div id='first-Name' class='d-none'>{{ firstName }}</div>
                  <div id='last-Name' class='d-none'>{{ lastName }}</div>
                </v-row>
                <v-row>
                  <v-dialog v-model='verifydialog' persistent width='500'>
                    <v-card color='primary' dark>
                      <v-card-text>
                        Verifying your email address...
                        <v-progress-linear
                          indeterminate
                          color='white'
                          class='mb-0'
                        ></v-progress-linear>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-row>
                <v-row>
                  <v-alert v-show='emailsuccess' type='success'>
                    Your email address is verified.
                  </v-alert>
                  <v-alert v-show='emailerror' type='error'>
                    We are not able to verify your e-mail. Please sign in via your
                    support website first. Redirecting to our support website...
                  </v-alert>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="getstartedmainframedialog = false"> Close </v-btn>
            
            <v-btn color='primary' @click="validateEmailAddress('mainframe')"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <v-dialog 
          v-model='mainframeinstructiondialog'
          fullscreen
          scrollable
          width='1200'
        >
        <template v-slot:activator='{ on, attrs }'>
          <v-container class="mainframesheet">
            <v-row>
              <v-col cols="4" class="w-600">
                <v-sheet height="250" class="rounded blue-grey darken-2">
                  <img class='calogo ma-8 rounded' src='../assets/ball.jpg' />
                  <v-btn large class='btn getstarted mainframe' v-bind='attrs' v-on='on'>
                    Mainframe
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <v-card
          class="white"
          light
          color="black"
          @keyup.enter="validateEmailAddress('mainframe')"
        >
          <v-card-title class='headline black lighten-2 white--text' primary-title>
            Mainframe Source Code Upload Instructions
          </v-card-title>

          <v-card-text>
            <MainframeInstructions></MainframeInstructions>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="black">
            <v-spacer></v-spacer>
            <v-btn @click="mainframeinstructiondialog = false"> Close </v-btn>
            
            <v-btn color='primary' @click="getstartedmainframedialog = true"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-footer absolute dark class='darkfooter'>
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }} CM First Group</div>
    </v-footer>
  </div>
</template>

<style>
html.dark,
.dark body,
.dark #app {
  height: 99%;
}
.welcomecontainer {
  height: 99%;
  background: #0F2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to bottom,
    #2C5364,
    #203A43,
    #0F2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to bottom,
    #2C5364,
    #203A43,
    #0F2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.darkfooter {
  background-color: #0f2027 !important;
  color: white !important;
}

#app {
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
</style>

<script>
import MainframeInstructions from './customwidgets/MainframeInstructions.vue'
import axios from 'axios'

async function checkemail(inputemail) {
  var config = {
    headers: {
      'content-type': 'application/json',
    },
  };
  try {
    let response = await axios.post(
       process.env.ROOT_API + '/emailcheck',
      {
        email: inputemail,
      },
      config
    );
    return response.data;
  } catch (exc) {
    console.log('exception: ', exc);
    return false;
  }
}

export default {
  name: 'Welcome',
  components: {
    MainframeInstructions
  },
  data() {
    return {
      getstarteddialog: false,
      getstartedmainframedialog: false,
      mainframeinstructiondialog:false,
      firstName: '',
      lastName: '',
      email: '',
      hint:
        'Enter the email address that you use to register on our support website',
      verifydialog: false,
      emailaddress: '',
      emailverified: false,
      emailsuccess: false,
      emailerror: false,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
    };
  },
  methods: {
    submit() {

    },
    validateEmailAddress: async function (platform) {
      if (this.emailaddress === '') {
        return false;
      }
      this.verifydialog = true;
      let emailresp = await checkemail(this.emailaddress);
      this.firstName = emailresp.firstName;
      this.lastName = emailresp.lastName;
      this.email = emailresp.email;
      if (emailresp === false) {
        this.emailerror = true;
        setTimeout(function () {
          window.location = 'https://support.cmfirstgroup.com/portal/signin';
        }, 1500);
      } else {
        this.emailsuccess = true;
        this.$emit('setFirstName', emailresp.firstName);
        this.$emit('setLastName', emailresp.lastName);
        this.$emit('setEmail', emailresp.email);
        if(platform == "plex") {
          this.$emit('changeTab', 'Upload');
        }
        if(platform == "mainframe") {
          this.$emit('changeTab', 'Stepper');
        }
      }
      this.verifydialog = false;
    },
      closePopup: function () {
      this.verifydialog = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue